import { useEffect, useState } from "react";
const useTabs = (tabs, initialSelectedTab)=>{
    const [selectedTab, setSelectedTab] = useState(initialSelectedTab);
    const [visibleTabs, setVisibleTabs] = useState(tabs?.length ? [
        initialSelectedTab
    ] : []);
    useEffect(()=>{
        if (tabs?.length && !visibleTabs.includes(initialSelectedTab)) {
            const newVisibleTabs = [
                ...visibleTabs
            ];
            newVisibleTabs.push(initialSelectedTab);
            setVisibleTabs(newVisibleTabs);
        }
        setSelectedTab(initialSelectedTab);
    }, [
        initialSelectedTab,
        tabs?.length,
        visibleTabs
    ]);
    return {
        selectedTab,
        visibleTabs
    };
};
export default useTabs;

//# sourceMappingURL=useTabs.js.map